import ReactGA from 'react-ga';

import mainConfig from './config/main.js';

const GA_MEASUREMENT_ID = 'G-32799R87KT';

export function init() {
  if (!window.gtag) {
    return;
  }

  window.gtag('js', new Date());

  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
  });
}

export function track(location) {
  if (!window.gtag) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: location.pathname
  });
}

/**
 * Initializes google analytics.
 
export function init() {
  if (!mainConfig.googleAnalytics.trackId) {
    return;
  }

  ReactGA.initialize(mainConfig.googleAnalytics.trackId);
}

/**
 * Reports the new location to GA.
 *
 * @param {{pathname: string}} newLocation

export function track(newLocation) {
  if (!mainConfig.googleAnalytics.trackId) {
    return;
  }

  ReactGA.set({page: newLocation.pathname});
  ReactGA.pageview(newLocation.pathname);
}
*/


// WEBPACK FOOTER //
// ./src/googleAnalytics.js